import { SET_DATA_MISTAKES_MODAL_MESSAGE } from '../../actions/types';

const initialState = {
  dataMistakesModalMessage: undefined
};
export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA_MISTAKES_MODAL_MESSAGE:
      return {
        ...state,
        dataMistakesModalMessage: action.payload
      };
    default:
      return state;
  }
}
